(function () {
  var conferenceWizardScrollPatchInitialized = false;
  var desktopCompactStorageKey = "conferenceWizardDesktopCompact";
  var desktopCompactDocClass = "conference-wizard-desktop-compact-pref";

  function readDesktopCompactPreference() {
    try {
      return window.localStorage.getItem(desktopCompactStorageKey) === "1";
    } catch (error) {
      return false;
    }
  }

  function syncDesktopCompactDocClass(enabled) {
    document.documentElement.classList.toggle(desktopCompactDocClass, enabled);
  }

  syncDesktopCompactDocClass(readDesktopCompactPreference());

  function disableFreeformAutoScrollForWizard() {
    if (conferenceWizardScrollPatchInitialized) {
      return;
    }

    conferenceWizardScrollPatchInitialized = true;

    document.addEventListener("freeform-ready", function (event) {
      if (!document.querySelector("[data-conference-wizard]")) {
        return;
      }

      var form = event.form || event.target;
      var freeformInstance = event.freeform || (form && form.freeform);

      if (event.options) {
        event.options.autoScroll = false;
        event.options.scrollToAnchor = false;
      }

      if (freeformInstance && typeof freeformInstance.setOption === "function") {
        freeformInstance.setOption("autoScroll", false);
        freeformInstance.setOption("scrollToAnchor", false);
      }

      if (freeformInstance && typeof freeformInstance._scrollToForm === "function") {
        freeformInstance._scrollToForm = function () {};
      }

      if (form instanceof Element && form.closest("[data-conference-wizard]")) {
        form.removeAttribute("data-auto-scroll");
        form.removeAttribute("data-scroll-to-anchor");
      }
    });
  }

  function initConferenceWizard() {
    var root = document.querySelector("[data-conference-wizard]");
    if (!root) {
      return;
    }

    var restoreScrollFlagKey = "conferenceWizardRestoreScroll";
    var restoreScrollYKey = "conferenceWizardRestoreScrollY";
    var panel = root.querySelector(".conference-wizard__panel");
    var openButton = root.querySelector("[data-conference-wizard-open]");
    var closeButton = root.querySelector("[data-conference-wizard-close-button]");
    var closeButtons = root.querySelectorAll("[data-conference-wizard-close]");
    var mobileMedia = window.matchMedia("(max-width: 991.98px)");
    var desktopCompactEnabled = false;

    if (!panel || !openButton) {
      return;
    }

    function isIntroTabLabel(label) {
      return (label || "").trim().toLowerCase() === "intro";
    }

    function updateWizardStepTabs() {
      var navTabs = root.querySelectorAll(".conference-wizard__form .nav-tabs");

      navTabs.forEach(function (navTab) {
        var activeLink = navTab.querySelector(".nav-link.active");
        var activeLabel = activeLink ? activeLink.textContent : "";
        var introActive = isIntroTabLabel(activeLabel);

        navTab.classList.toggle("is-intro-active", introActive);

        navTab.querySelectorAll(".nav-item").forEach(function (item) {
          var link = item.querySelector(".nav-link");
          var label = link ? link.textContent : "";
          item.classList.toggle("is-intro-tab", isIntroTabLabel(label));
        });
      });
    }

    function queueUpdateWizardStepTabs() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(updateWizardStepTabs);
      });
    }

    function writeDesktopCompactPreference(enabled) {
      try {
        window.localStorage.setItem(desktopCompactStorageKey, enabled ? "1" : "0");
        syncDesktopCompactDocClass(enabled);
      } catch (error) {
        // Ignore storage errors.
      }
    }

    function applyDesktopCompactState(enabled) {
      desktopCompactEnabled = enabled;

      if (enabled) {
        root.classList.add("is-desktop-compact");
      } else {
        root.classList.remove("is-desktop-compact");
      }
    }

    function rememberScrollBeforePageSwitch(event) {
      var submitTrigger = event.target.closest('button[type="submit"], input[type="submit"]');
      if (!submitTrigger) {
        return;
      }

      try {
        sessionStorage.setItem(restoreScrollFlagKey, "1");
        sessionStorage.setItem(restoreScrollYKey, String(window.scrollY || 0));
      } catch (error) {
        // Ignore storage errors.
      }
    }

    function restoreScrollAfterPageSwitch() {
      try {
        if (sessionStorage.getItem(restoreScrollFlagKey) !== "1") {
          return;
        }

        sessionStorage.removeItem(restoreScrollFlagKey);

        var y = parseInt(sessionStorage.getItem(restoreScrollYKey) || "0", 10);
        if (Number.isNaN(y)) {
          y = 0;
        }

        window.scrollTo(0, y);
        setTimeout(function () {
          window.scrollTo(0, y);
        }, 60);
        setTimeout(function () {
          window.scrollTo(0, y);
        }, 240);
      } catch (error) {
        // Ignore storage errors.
      }
    }

    panel.addEventListener("click", rememberScrollBeforePageSwitch);
    restoreScrollAfterPageSwitch();
    updateWizardStepTabs();

    document.addEventListener("freeform-ready", function (event) {
      var form = event.form || event.target;
      if (!(form instanceof Element) || !form.closest("[data-conference-wizard]")) {
        return;
      }

      queueUpdateWizardStepTabs();
    });

    panel.addEventListener("submit", function (event) {
      var form = event.target;
      if (!(form instanceof Element) || !form.matches("form[data-freeform]")) {
        return;
      }

      queueUpdateWizardStepTabs();
      setTimeout(updateWizardStepTabs, 120);
      setTimeout(updateWizardStepTabs, 300);
    });

    var wizardFormContainer = panel.querySelector(".conference-wizard__form");
    if (wizardFormContainer && typeof MutationObserver !== "undefined") {
      var observer = new MutationObserver(function () {
        queueUpdateWizardStepTabs();
      });

      observer.observe(wizardFormContainer, {
        childList: true,
        subtree: true,
      });
    }

    function closeWizard() {
      root.classList.remove("is-open");
      document.body.classList.remove("conference-wizard-open");
      openButton.setAttribute("aria-expanded", "false");
      panel.setAttribute("aria-hidden", "true");
    }

    function openWizard() {
      root.classList.add("is-open");
      if (mobileMedia.matches) {
        document.body.classList.add("conference-wizard-open");
      } else {
        document.body.classList.remove("conference-wizard-open");
      }
      openButton.setAttribute("aria-expanded", "true");
      panel.setAttribute("aria-hidden", "false");
    }

    openButton.addEventListener("click", function () {
      if (!mobileMedia.matches && desktopCompactEnabled) {
        applyDesktopCompactState(false);
        writeDesktopCompactPreference(false);
        root.classList.remove("is-open");
        panel.removeAttribute("aria-hidden");
        openButton.setAttribute("aria-expanded", "false");
        return;
      }

      if (!mobileMedia.matches) {
        return;
      }

      if (root.classList.contains("is-open")) {
        closeWizard();
      } else {
        openWizard();
      }
    });

    closeButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        if (!mobileMedia.matches && button === closeButton) {
          applyDesktopCompactState(true);
          writeDesktopCompactPreference(true);
        }

        closeWizard();
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && root.classList.contains("is-open")) {
        closeWizard();
      }
    });

    function syncLayoutState() {
      if (mobileMedia.matches) {
        if (!root.classList.contains("is-open")) {
          panel.setAttribute("aria-hidden", "true");
        }

        return;
      }

      document.body.classList.remove("conference-wizard-open");

      if (desktopCompactEnabled) {
        if (root.classList.contains("is-open")) {
          panel.setAttribute("aria-hidden", "false");
          openButton.setAttribute("aria-expanded", "true");
        } else {
          panel.setAttribute("aria-hidden", "true");
          openButton.setAttribute("aria-expanded", "false");
        }

        return;
      }

      root.classList.remove("is-open");
      openButton.setAttribute("aria-expanded", "false");
      panel.removeAttribute("aria-hidden");
    }

    if (typeof mobileMedia.addEventListener === "function") {
      mobileMedia.addEventListener("change", syncLayoutState);
    } else if (typeof mobileMedia.addListener === "function") {
      mobileMedia.addListener(syncLayoutState);
    }

    applyDesktopCompactState(readDesktopCompactPreference());
    syncLayoutState();
  }

  disableFreeformAutoScrollForWizard();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initConferenceWizard);
  } else {
    initConferenceWizard();
  }
})();
